import React from "react";
import { getColor } from "../util/CC";
import { Button, Space, Form, Input, Spin } from "antd";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import Html from "../components/utilities/Html";

export default function ConstantContactEmbedded(props) {

    const template = window.sitesettings.template_info;
    const { content = {} } = props;

    const {
        location = "main",
        component = "constant_contact_embedded",
        container = true,
        data = {},
    } = content;

    const {
        form_id = "",
        background_colour = 0,
        contained = false,
        width = 1248,
        height = 400,
        align = "0 auto",
        padding_x = 10,
        padding_y = 10,
    } = data;

    const drawRender = () => {

        let _style = {
            padding: padding_y + "px " + padding_x + "px",
            background: getColor(background_colour, template)
        }

        return (
            <div className={(container) ? "preview-container" : ""}>
                <div style={_style} >
                    <div style={{ maxWidth: (contained) ? width + "px" : "100%", margin: align, }}>
                        {(form_id &&
                            <Html html={`
                        <iframe
                            id="ccFormIframe"
                            data-ctct-m="${form_id}"
                            src="/cc.html"
                            width="100%"
                            height="${height}"
                            frameborder="0"
                            scrolling="yes">
                        </iframe>    
                        `} />
                        )}
                    </div>
                </div>
            </div>
        )
    }

    return drawRender();
}